import React from 'react'
import { Helmet } from "react-helmet"
import loadable from '@loadable/component'
// import '../components/MTAEoY2025Content.scss'

const MTAEoY2025Content = loadable(() => import('../components/MTAEoY2025Content'))

const MTAEoY2025 = () => {

  return (
    <>
      <Helmet>
        <title>MTA + Alopex 2025 Year in Review</title>
        <link rel="stylesheet" href="https://use.typekit.net/hoh4grq.css"></link>
      </Helmet>
      <MTAEoY2025Content />
    </>
  )
}

export default MTAEoY2025